// The Master cell: on a child course, its master's course number in the monospace style, linking to the
// master's Reader and truncating with its full value disclosed; on any other course, the house dash.

import React from 'react'
import PropTypes from 'prop-types'

import { InlineLink } from '@CommonComponents/buttons'
import { Clipped } from '../../components/me_table/cells/InteractiveCells'
import { Dash } from './InstructorBadges'

export const NO_MASTER = 'No master course'

/** The master's course number on a child course; null on a master or a course with none. */
export const masterOf = row => {
  const master = row.master_coursenum
  return master && master !== row.coursenum ? master : null
}

export const MasterCell = ({ row }) => {
  const master = masterOf(row)
  if (!master || !row.master_href) return <Dash label={NO_MASTER} />
  return (
    <span className="me-table-id admin-courses-master">
      <Clipped text={master}>
        <InlineLink href={row.master_href}>{master}</InlineLink>
      </Clipped>
    </span>
  )
}

MasterCell.propTypes = {
  row: PropTypes.shape({
    coursenum: PropTypes.string,
    master_coursenum: PropTypes.string,
    master_href: PropTypes.string,
  }).isRequired,
}
